import * as _ from "lodash";
import {
  VisitScheduleDailyStatusModel,
  VisitScheduleOverviewModel,
  VisitScheduleOverviewReportModel
} from "./visit-schedule-overview.model";

export function mapVisitScheduleOverviewToReport(overview: VisitScheduleOverviewModel,
                                                 from?: number,
                                                 to?: number): VisitScheduleOverviewReportModel {
  const dailyStatuses = _getDailyStatusesInRange(overview.dailyStatuses, from, to);
  const totals = _aggregateDailyStatusTotals(dailyStatuses);
  const status = _resolveOverviewStatus(dailyStatuses);

  return {
    ...overview,
    status: status,
    totalJobs: totals.totalJobs,
    totalRoutes: totals.totalRoutes,
    publishedRoutes: totals.publishedRoutes,
    dispatchedRoutes: totals.dispatchedRoutes
  };
}

function _getDailyStatusesInRange(dailyStatuses: VisitScheduleDailyStatusModel[],
                                  from?: number,
                                  to?: number): VisitScheduleDailyStatusModel[] {
  if (!dailyStatuses?.length) {
    return [];
  }

  if (!from && !to) {
    return dailyStatuses;
  }

  return dailyStatuses.filter((dailyStatus) => {
    const date = dailyStatus.date;
    if (!date) {
      return true;
    }
    if (from && date < from) {
      return false;
    }
    if (to && date > to) {
      return false;
    }
    return true;
  });
}

function _aggregateDailyStatusTotals(dailyStatuses: VisitScheduleDailyStatusModel[]) {
  const totals = {
    totalJobs: 0,
    totalRoutes: 0,
    publishedRoutes: 0,
    dispatchedRoutes: 0
  };

  dailyStatuses.forEach((dailyStatus) => {
    totals.totalJobs += dailyStatus.totalJobs || 0;
    totals.totalRoutes += dailyStatus.totalRoutes || 0;
    totals.publishedRoutes += dailyStatus.publishedRoutes || 0;
    totals.dispatchedRoutes += dailyStatus.dispatchedRoutes || 0;
  });

  return totals;
}

function _resolveOverviewStatus(dailyStatuses: VisitScheduleDailyStatusModel[]) {
  if (!dailyStatuses?.length) {
    return undefined;
  }

  const latestDailyStatus = _.maxBy(dailyStatuses, (dailyStatus) => dailyStatus.date || 0);
  return latestDailyStatus?.status;
}
